export const numberFormatter = ({
  value,
  decimal = 2
}: {
  value: number;
  decimal?: number;
}): string => {
  const tempN = +`${Math.floor(value)}e${decimal ? -decimal : -0}`;
  return tempN.toLocaleString('en-US', {
    minimumFractionDigits: 0,
    maximumFractionDigits: decimal
  });
};

const prepareMultiplier = ({
  buyIn,
  prizePool,
  isPlayMoney
}: {
  buyIn: number; // dollar value *100
  prizePool: number; // dollar value *100
  isPlayMoney?: boolean;
}) => {
  if (buyIn > 0) {
    return prizePool / buyIn;
  }
  if (isPlayMoney) {
    return prizePool / 10000;
  }
  return prizePool;
};

export const multiplierHelper = ({
  buyIn,
  prizePool,
  isPlayMoney
}: {
  buyIn: number; // dollar value *100
  prizePool: number; // dollar value *100
  isPlayMoney?: boolean;
}) => {
  const value = prepareMultiplier({ buyIn, prizePool, isPlayMoney }) * 100;
  return numberFormatter({ value, decimal: 2 });
};
